import e from "react";
import t from "./infoPage.module.scss.js";
function n({
  title: a
}) {
  return /* @__PURE__ */ e.createElement("div", { "data-testid": "info-page", className: t.infoPage }, /* @__PURE__ */ e.createElement("div", { className: t.infoPage__text }, a));
}
export {
  n as InfoPage
};
//# sourceMappingURL=InfoPage.js.map
